export default {
  getList: {
    method: 'post',
    url: '/client/vehicle/remooc-category/list'
  },
  add: {
    method: 'post',
    url: '/client/vehicle/remooc-category'
  },
  delete: {
    method: 'delete',
    url: '/client/vehicle/remooc-category'
  },
  archive: {
    method: 'delete',
    url: '/client/vehicle/remooc-category/archive'
  },
  restore: {
    method: 'put',
    url: '/client/vehicle/remooc-category/restore'
  },
  edit: {
    method: 'put',
    url: '/client/vehicle/remooc-category/id'
  },
  find: {
    method: 'get',
    url: '/client/vehicle/remooc-category/find?key=KEY'
  },
  detail: {
    method: 'get',
    url: '/client/vehicle/remooc-category/detail/ID'
  }
}
